import React from 'react';
import { ACTION_ORDER, ActionKey } from './actions';
import { cx } from './cx';

interface RowActionsProps {
  children: React.ReactNode;
  /** Alinha à direita no desktop (coluna "Ações" de tabela). */
  align?: 'start' | 'end';
  className?: string;
}

const orderOf = (child: React.ReactNode) => {
  if (!React.isValidElement(child)) return 0;
  const action = (child.props as { action?: ActionKey }).action;
  return (action && ACTION_ORDER[action]) || 0;
};

/**
 * Container das ações de um item. Mobile: grade de botões rotulados com separador acima;
 * desktop: linha de ícones. Garante a ordem — ações destrutivas (Excluir/Remover) sempre por último.
 */
const RowActions: React.FC<RowActionsProps> = ({ children, align = 'start', className }) => {
  const items = React.Children.toArray(children)
    .filter(Boolean)
    .sort((a, b) => orderOf(a) - orderOf(b));

  return <div className={cx('row-actions', align === 'end' && 'md:justify-end', className)}>{items}</div>;
};

export default RowActions;
